import AuthorizationStore from './authorization';
import MenuStore from './menu';
import CommonsStore from './commons';
import Payload  from './payload';
import MyaaffiliateStore from './myaaffiliate'
import CampaignStore from './campaign'
import AdvertisementsStore from './advertisements'
import ReferralStore from './referral'
import TierreportStore from './tierreport'
import UpdateinfoStore from './updateinfo'
import CpacommissionStore from './cpacommission'
import TransactionsModuleStore from './transactionsmodule'
import CountryStore from './country'
import PlayersStore from './players'
import IntroductionStore from "./introduction";
import NewsStore from './news';
import MediaLandingPageStore from './media_landingpage'


export {
    Payload,
    AuthorizationStore,
    MenuStore,
    CommonsStore,
    MyaaffiliateStore,
    CampaignStore,
    AdvertisementsStore,
    ReferralStore,
    TierreportStore,
    UpdateinfoStore,
    CpacommissionStore,
    TransactionsModuleStore,
    CountryStore,
    PlayersStore,
    IntroductionStore,
    NewsStore,
    MediaLandingPageStore
}


